/**
 * Generate a unique ID for resume builder components
 */
export function generateId(): string {
  return crypto.randomUUID().slice(0, 8);
}
